import Config from "@/vuex/Config";
import Status from "@/vuex/Status";
import CatchFetch from "@/assets/Cache/Fetch";
import Logger from "@/assets/Helper/Logger";
import SetData from "@/vuex/SetData";

class JewelleryViewer3d {
    getSet(setId, filename) {
        if (typeof setId == 'string' && setId != '') {
            Status.dispatch('setLoading', true).catch((error) => {
                Logger.error(error);
            });

            let baseSet = this.getBaseSet(setId.toString());

            filename = filename.toString().trim();
            if (filename == '') {
                filename = baseSet;
            }

            return new Promise((resolve, reject) => {
                CatchFetch.cacheFirst(Config.getters.getApi123GoldHost + '/item/jewelleryViewer/?folder=' + this.getFolder() + '&baseSet=' + baseSet + '&filename=' + filename)
                    .then(json => {
                        if (typeof json.isJewelleryViewer == 'boolean') {
                            resolve(json);
                        } else {
                            resolve(false);
                        }

                        Status.dispatch('setLoading', false).catch((error) => {
                            Logger.error(error);
                        });
                    })
                    .catch((error) => {
                        Status.dispatch('setLoading', false).catch((error) => {
                            Logger.error(error);
                        });
                        Logger.error(error);
                        reject(false);
                    });
            });
        } else {
            return new Promise((resolve) => {
                resolve(false);
            });
        }
    }

    getBaseSet(setId) {
        return setId.trim().toLowerCase().slice(0, setId.lastIndexOf('-'));
    }

    getFolder() {
      const currentItem = SetData.getters.getCurrentItem;

      let jewelleryType = 0;
      if (currentItem && currentItem.description && currentItem.description.jewelleryType > 0) {
        jewelleryType = parseInt(currentItem.description.jewelleryType);
      }

      let folder = 'rings';
      if (jewelleryType === 21 || jewelleryType === 4 || jewelleryType === 11) {
        folder = 'chains';
      } else if (jewelleryType === 1) {
        folder = 'earrings';
      } else if (jewelleryType === 7) {
        folder = 'bracelets';
      } else if (jewelleryType === 5) {
        folder = 'diamonds';
      }

      return folder;
    }

    getData(items, currentItem) {
        Status.dispatch('setLoading', true).catch((error) => {
            Logger.error(error);
        });

        let itemnumberStr = '';

        if (currentItem === 'set' && typeof items[0] == 'string') {
            for (let numericKey in items) {
                itemnumberStr += items[numericKey] + '/';
            }
        } else {
            itemnumberStr = SetData.getters.getItemStr.replaceAll("_", "/") + '/';
        }

        return new Promise((resolve, reject) => {
            CatchFetch.cacheFirst(Config.getters.getApiHostWithLocalStr + '/v2/items/description3d/' + itemnumberStr)
                .then(json => {
                    if (json.status === true && typeof json.result == 'object') {
                        SetData.dispatch('setItemDescription3d', json.result.items).catch((error) => {
                            Logger.error(error);
                        });
                        resolve(json);
                    } else {
                        resolve(false);
                    }

                    Status.dispatch('setLoading', false).catch((error) => {
                        Logger.error(error);
                    });
                })
                .catch((error) => {
                    Status.dispatch('setLoading', false).catch((error) => {
                        Logger.error(error);
                    });
                    Logger.error(error);
                    reject(false);
                });
        });
    }

    loadViewer() {
        return new Promise((resolve, reject) => {
            fetch(Config.getters.getJewelleryViewer3dHost + '/plugin/dist/plugin.js')
                .then((response) => response.text())
                .then((text) => eval(text))
                .then(() => {
                    resolve(true)
                })
                .catch(() => {
                    reject(false);
                });
        });
    }
}

export default new JewelleryViewer3d();
